'use client';

import { useEffect } from 'react';
import { useTheme } from '@/lib/integrations/theme';

export function ThemeColorUpdater() {
  const { theme } = useTheme();

  useEffect(() => {
    const themeColorMeta = document.querySelector('meta[name="theme-color"]');
    const color = theme === 'dark' ? '#1A1A1A' : '#FAFAFA';
    
    if (themeColorMeta) {
      themeColorMeta.setAttribute('content', color);
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('name', 'theme-color');
      meta.setAttribute('content', color);
      document.head.appendChild(meta);
    }
  }, [theme]);

  return null;
}

